// PrintScheduleDateRange

export default function PrintScheduleDateRange( JobSchedulerService ) {
	"ngInject";
	return function ( input, optional1, optional2 ) {
        if ( !input ) return "";

        return JobSchedulerService.getDateRange( input, true );
      };
}
